import type { ChartMargin } from "./chart.ts";
import { ChartPad, type ChartTheme, ChartThemeDark, ChartUnit } from "../utils/theme.ts";

export type ChartMode = "editor" | "inline";

export interface ChartSize {
  width?: number;
  height: number;
  pad: number;
}

export const InlineSize: ChartSize = { height: Math.round(ChartUnit * 0.75), pad: 1 };

export function EditorSize(columns: number, rows: number, pad = ChartPad): ChartSize {
  return { width: columns * ChartUnit, height: rows * ChartUnit, pad };
}

export function ModeSize(mode: ChartMode, editor: ChartSize, inline = InlineSize): ChartSize {
  return mode === "editor" ? editor : inline;
}

export function ModeTheme(mode: ChartMode, theme: ChartTheme = ChartThemeDark): ChartTheme {
  return mode === "inline" ? { ...theme, strokeWidth: 1 } : theme;
}

export function PadMargin(pad: number): ChartMargin {
  return { top: pad, right: pad, bottom: pad, left: pad };
}
